import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ALL_CONTACT_EMAIL_TYPES } from "../../shared/types";

interface Props {
	name: string;
	label: string;
	disabled?: boolean;
}

export const EmailTypeSelectField: FC<Props> = ({ name, label, disabled }) => {
	const { t } = useTranslation();

	return (
		<SingleSelectField
			options={ALL_CONTACT_EMAIL_TYPES.map((e) => ({ label: t(e), value: e }))}
			getLabel={(x) => x.label}
			getValue={(x) => x.value}
			name={name}
			label={label}
			clearable={false}
			disabled={disabled}
		/>
	);
};
